import React from "react";

export default function Hero() {
 return (
  <section className="hero" id="hero">
   <h1>Welcome to HR Solutions</h1>
   <p>Your partner in building a better workplace.</p>
   <a href="#services" className="cta-button">Explore Our Services</a>
  </section>
 );
}